import useRole from "../hooks/userRole";

const RoleGuard = ({ task, parentTask, table = 'ss', requireCRUD = false, children, fallback = null }) => {
    const { hasAccess, hasOptionAccess } = useRole();

    const allowed = parentTask
        ? (Array.isArray(parentTask)
            ? parentTask.some(pt => hasOptionAccess(pt, task, table, requireCRUD))
            : hasOptionAccess(parentTask, task, table, requireCRUD))
        : hasAccess(task, table, requireCRUD);

    return allowed ? children : fallback;
};

export default RoleGuard;